<template>
  <v-app-bar color="#102a63" theme="dark" height="80">
    <v-row>
      <v-col lg="8">
        <img class="logoBaps" src="../assets/logo.svg" />
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<style scoped>
.logoBaps {
  width: 334px !important;
  height: 45px !important;
}
</style>
